<template>
	<div>
		<!--New page-->
		<h1>Study Information</h1>

		<i>General information of the trial</i>

		<InputTextSingleLine
			question="Where was the trial registered OR where do you intend to register it?"
			placeholder="e.g. https://clinicaltrials.gov, https://www.who.int/clinical-trials-registry-platform"
			v-model="$tera.project.TrialWizard.trialRegistered"
			bookmark="trial-registered"
		/>

		<InputTextSingleLine
			question="What is the trial registration number?"
			placeholder="e.g. NCT05555953"
			v-model="$tera.project.TrialWizard.trialRegistNumber"
			bookmark="registeration-number"
		/>

		<InputTextSingleLine
			question="What is the version of the protocol?"
			placeholder="e.g. 1, 2"
			v-model="$tera.project.TrialWizard.protocolVersion"
			bookmark="protocol-version"
		/>

		<InputElDate
			question="What date was / will be the protocol registered?"
			placeholder="e.g. 15 April 2024"
			v-model="$tera.project.TrialWizard.protocolDate"
			bookmark="registration-date"
		/>

		<InputTextMultiLine
			question="Identify the sources and types of financial, material, and other support"
			placeholder="e.g. The authors declare that they have no known competing financial interests or personal relationships that could have appeared to influence the work reported in this paper."
			v-model="$tera.project.TrialWizard.supports"
			bookmark="financial-sources"
		/>

		<InputTextSingleLineMulti
			question="Who is the sponsor or funders of the study?"
			placeholder="e.g. NHMRC, MRFF, NIH, CIHR"
			v-model="$tera.project.TrialWizard.sponsors"
			bookmark="study-sponsors"
		/>

		<InputTextMultiLine
			question="What is the role of the funders or sponsors in the study?"
			placeholder="e.g.  The funders are responsible in the study design, collection, management, analysis and interpretation of data, writing of the report;

The decision to submit the report for publication:
The sponsor or funder have/have not ultimate authority over any of these activities"
			v-model="$tera.project.TrialWizard.sponsorRole"
			bookmark="sponsors-role"
		/>

		<InputTextMultiLine
			question="What is the contact name and information of the sponsor?"
			:placeholder="infoPlaceholder"
			v-model="$tera.project.TrialWizard.sponsorInfo"
			bookmark="sponsors-information"
		/>

		<InputTextMultiLine
			question="Description of research question and justification for undertaking the trial, including summary of relevant studies (published and unpublished) examining benefits and harms for each intervention"
			placeholder="e.g. we reviewed the literature for articles that mention, describe, validate, or apply methods for screening or assessing research misconduct in health-related research."
			v-model="$tera.project.TrialWizard.reDescription"
			bookmark="research-description"
		/>

		<InputTextMultiLine
			question="What is the specific objectives or hypotheses of this research?"
			placeholder="e.g. give an overview of the available methods to investigate research misconduct in health-related research"
			v-model="$tera.project.TrialWizard.researchObjectives"
			bookmark="specific-objectives"
		/>

		<InputTextMultiLine
			question="Biological specimens: Plans for collection, laboratory evaluation, and storage of biological specimens for genetic or molecular analysis in the current trial and for future use in ancillary studies, if applicable"
			placeholder="e.g. Non-fasting blood samples were taken at baseline, 6 and 12 weeks and collected at the same time as chemotherapy treatment blood draws whenever possible. Serum was separated by centrifugation within 4 hours of collection and stored at -80oC until analysis. Serum was batch analysed for 25(OH) D concentrations at the AusSun Research laboratory at the Queensland University of Technology using Diasorin® liaison semi-automated chemoluminescence immunoassay (DiaSorin)."
			v-model="$tera.project.TrialWizard.bioSpecimens"
			bookmark="biological-specimens"
		/>

		<!--TODO: Waiting output content-->
		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>
<script>
import InputTextMultiLine from "../../components/InputTextMultiLine.vue";
import InputTextSingleLineMulti from "../../components/InputTextSingleLineMulti.vue";
import InputTextSingleLine from "../../components/InputTextSingleLine.vue";
import InputElDate from "../../components/InputElDate.vue";
import OutputStudyInformation from "./OutputStudyInformation.vue";

export default {
	name: "studyInformation",
	components: {
		InputTextMultiLine,
		InputTextSingleLineMulti,
		InputTextSingleLine,
		InputElDate
	},
	data() {
		return {
			outputComponent: OutputStudyInformation
		};
	},
	computed: {
		infoPlaceholder() {
			let placeholder = "";
			this.$tera.project.TrialWizard.sponsors?.forEach(el => {
				if (el) {
					placeholder += el + ", sponsor@email.com \n";
				} else {
					if (this.$tera.project.TrialWizard.sponsors.length <= 1) {
						placeholder = "e.g. Justin Graf, NHMRC, j.graf@nhmrc.gov.au";
					}
				}
			});
			return placeholder;
		}
	}
};
</script>
<style></style>
